import { render, staticRenderFns } from "./AboutAuthenticators.vue?vue&type=template&id=72536e5c&"
import script from "./AboutAuthenticators.vue?vue&type=script&lang=js&"
export * from "./AboutAuthenticators.vue?vue&type=script&lang=js&"
import style0 from "./AboutAuthenticators.vue?vue&type=style&index=0&id=72536e5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports